export default __webpack_public_path__ + "static/base-agency-balthazaurus-scroll-de89ab8da32737cdef0960ec6406c57e.gif";